export default __webpack_public_path__ + "images/icon_container_e93276a924e55fa7629099f45b6408d3.png";